import React from "react";
import ProjectDetailN8N from "../Components/n8nProjectDetail";
import { n8nProjectDetails } from "../Details";

function ProjectsN8N() {
  return (
    <main className="container mx-auto max-width pt-10 mb-20">
      <section>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          AI Automation Projects (n8n)
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10">
          {React.Children.toArray(
            n8nProjectDetails.map(
              ({ title, image, description, techstack, previewLink, githubLink }) => (
                <ProjectDetailN8N
                  title={title}
                  image={image}
                  description={description}
                  techstack={techstack}
                  previewLink={previewLink}
                  githubLink={githubLink}
                />
              )
            )
          )}
        </div>
      </section>
    </main>
  );
}

export default ProjectsN8N;
